import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getWidgetData } from "api/Dashboard";



interface WidgetDataProps {
    endpoint: string;
    params: any;
    type?: string;
}

export const useWidgetData = ({ endpoint, params, type }: WidgetDataProps) => {

    return useQuery<Array<any> | any>(
        ['widgetData', type, params],
        () => getWidgetData(endpoint, params),
        {
            onError() {
                toast.error("Failed to fetch assigned appointments");
            },
        }
    );

};
